import { toPx } from "./units";
export function applyMaxLines(lines, lineHeight) {
    return {
        overflow: "hidden",
        "box-sizing": "content-box",
        "max-height": toPx(lines * lineHeight),
        "white-space": lines === 1 ? "nowrap" : null,
    };
}
